import React from "react";
import getClassName from "../../utilities/getClassName";
import { getIcon } from "../../utilities/icon";
import ThemedIcon from "./ThemedIcon";

const Button = React.forwardRef(({ onClick, classNames, disabled, children, icon, active, animate, themedIcon }, ref) => {
    const iconSrc = getIcon(icon);

    let className = ["button"];
    if (active) {
        className = ["button button--active"];
    }

    if (typeof classNames === "object") {
        className = className.concat(classNames);
    }

    return (
        <button disabled={disabled} onClick={onClick} ref={ref} className={getClassName(className)}>
            {iconSrc.length > 0 && (
                <figure className="button__icon">
                    {iconSrc.map((src, i) => {
                        // themedIcon: render as a CSS mask so the icon follows the button text colour
                        return themedIcon ? (
                            <ThemedIcon src={src} className="button__themed-icon" key={i} />
                        ) : (
                            <img src={src} alt="" key={i} />
                        );
                    })}
                </figure>
            )}
            {children}
            {animate && (
                <>
                    <div className="button__animate-1"></div>
                    <div className="button__animate-2"></div>
                </>
            )}
        </button>
    );
});

export default Button;
